import {getHexFromColorText} from '../../../../utils'
import {cx} from '../../../../utils/classNameUtil'
import {userUtil} from '../../../../utils/userUtil'
import {DIALOG_AVATAR_IMAGE_URL} from '../../../../constants/dialogConstants'
import styles from './DialogAvatar.module.scss'

interface IDialogAvatarProps {
  // Name shown next to the avatar — the avatar username, or the translated
  // "Moderator" label. Initials and the fallback colour are derived from it.
  displayName: string
  // Public users pick an illustrated avatar; its image is looked up by
  // username. Moderators have none, so they always get the initials circle.
  avatarUsername?: string
}

export const DialogAvatar: React.FC<IDialogAvatarProps> = ({
  displayName,
  avatarUsername,
}) =>
  avatarUsername ? (
    <img
      src={`${DIALOG_AVATAR_IMAGE_URL}${avatarUsername}`}
      alt=""
      loading="lazy"
      className={styles.avatar}
      style={{
        backgroundColor: getHexFromColorText(avatarUsername.split(' ')[0]),
      }}
    />
  ) : (
    <div
      className={cx(styles.avatar, styles.avatarLetter)}
      style={{backgroundColor: userUtil.getAvatarColor(displayName)}}
      aria-hidden="true"
      data-testid="dialog-avatar-initials"
    >
      {userUtil.getInitials({username: displayName})}
    </div>
  )
